/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/325-circle-left': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 16A8 8 0 108 0a8 8 0 000 16zM8 1.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"/><path pid="1" d="M10.457 4.957L9.043 3.543 4.586 8l4.457 4.457 1.414-1.414L7.414 8z"/>'
  }
})
